import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Badge } from '../badge';
import translationFallback from '../i18n/en-US/translation.json';
import { ScreenReaderOnly } from '../screen-reader-only';
import { countStyle } from './styles';
function Counter({ count, size, variant }) {
    const { ready, t } = useTranslation();
    const counterVariant = variant === 'primary' ? 'navy' : 'white';
    const shouldUseBaseVariant = variant === 'plain' || variant === 'secondary';
    return (_jsxs(Badge, Object.assign({ css: countStyle({ size }), "data-testid": "button-counter", size: size, variant: shouldUseBaseVariant ? 'base' : counterVariant }, { children: [_jsxs(ScreenReaderOnly, { children: [ready ? t('Counter.label') : translationFallback.Counter.label, ': '] }), count] })));
}
export default Counter;
